import { InjectionToken, Provider, Type } from '@angular/core';

import { environment } from 'src/environments/environment';

/**
 * Returns a `Provider` that binds `token` to either the mock or HTTP
 * implementation based on `environment.useMockData`.
 *
 * Usage in a feature `providers` array (route or component) or in
 * `app.config.ts`:
 *
 * ```ts
 * provideRepository(CART_REPOSITORY, CartMockRepository, CartHttpRepository)
 * ```
 *
 * Both implementations must satisfy the same interface declared on the token.
 * Switching to real APIs in a given environment is a single-flag change in
 * `environment.<env>.ts`.
 */
export function provideRepository<T>(token: InjectionToken<T>, mockImpl: Type<T>, httpImpl: Type<T>): Provider {
  return { provide: token, useClass: environment.useMockData ? mockImpl : httpImpl };
}
